// import { Report55Container } from "../../../containers/SupportSystem/Reports/Report55Container";
import { ListReportSupportContainer } from "../../../containers/SupportSystem/Reports/ListReportSupportContainer";
export function ListReportSupportPage() {
    return (
        <ListReportSupportContainer />
    );

}